import React, { useEffect, useState, useContext, useRef } from "react";
// import "spectre.css/dist/spectre.min.css";
import styled from "styled-components";
import BreadCrumbsNavbar from "../components/BreadCrumbsNavbar";
import Showhide from "../components/Showhide";
import { FiExternalLink } from "react-icons/fi";
import { FaReact } from "react-icons/fa";
import { MdAndroid } from "react-icons/md";
import hljs from "highlight.js";
import "highlight.js/styles/ocean.css";

import {
	Code,
	ScrollingCard,
	Main,
	SandboxContainer,
	DeveloperContainer,
	SwitchDeveloper,
	OutlineButton,
} from "../components/common";
import "./Sandbox.scss";
import { python, java, nodejs, ruby, go } from "./codes.js";

import AppContext from "../context/AppContext";

const RowContainer = styled.div`
	display: flex;
	width: 80%;
	flex: 1;
	align-items: center;
	margin-bottom: 10px;
	justify-content: space-between;
	.key {
	}
	.value {
		width: 450px;
	}
	@media (max-width: 786px) {
		align-items: baseline;
		flex-direction: column;
		width: 100%;
		.value {
			margin-top: 10px;
			width: 100%;
		}
	}
`;
const Label = styled.span`
	margin: 0;
	border: 1px solid #3e3e3e;
	border-radius: 4px;
	padding: 8px 32px;
	font-weight: 700;
	font-size: 14px;
	background: ${(props) => (props.active ? "#3e3e3e" : "none")};
	cursor: pointer;
	color: ${(props) => (props.active ? "white" : "#3e3e3e")};
`;
const LanguageList = styled.ul`
  display: flex;
  margin: 0 0 10px 0;
  height: fit-content;
  min-height:50px;
  overflow-x:scroll;
  li {
    margin-right: 1rem;
    list-style-type: none;
    width: fit-content;

    /* a {
      text-decoration: none;
      color: #c4c4c4;
      display: flex;
      align-items: center;
      transition: 0.1s color;
    }
    a:hover {
      color: white;
      cursor: pointer;
    }
    a:focus {
      box-shadow: none;
    }
    &:hover ${Label} {
      color: white;
      cursor: pointer;
    } */
  }
`;

function Sandbox(props) {
	const high = useRef();

	const [key, setKey] = useState("");
	const [language, setLanguage] = useState("python");
	const context = useContext(AppContext);
	const [env, setEnv] = useState("dev");

	useEffect(() => {
		getKey();
		// console.log(javascript);

		import(`highlight.js/lib/languages/${language}`).then((lang) => {
			console.log(lang.default);
			hljs.registerLanguage(language, lang.default);
			highlight();
		});
	}, [language]);

	const highlight = () => {
		// console.log(high);
		if (high) {
			const nodes = high.current.querySelectorAll("pre");
			nodes.forEach((node) => {
				hljs.highlightBlock(node);
			});
		}
	};

	const getKey = async () => {
		let fT = context.token;
		const ftData = JSON.parse(fT);

		var myHeaders = new Headers();
		myHeaders.append("token", ftData.Token);
		var requestOptions = {
			method: "GET",
			headers: myHeaders,
			redirect: "follow",
		};
		let response;
		try {
			response = await fetch(
				`https://dashboardapi.finbox.in/v1/developer/bank_connect`,
				requestOptions
			);
		} catch (err) {
			context.removeToken();
			window.location.href = "/";
			return;
		}
		const resp = await response.text();
		const json = JSON.parse(resp);
		setKey(json.Data);
	};

	return (
		<Main style={{ background: "#f9f9f9" }}>
			{/* <BreadCrumbsNavbar
        loc={[
          { name: "BankConnect", link: "/bankconnect" },
          { name: "Sandbox", link: props.location.pathname },
        ]}
      /> */}
			<SandboxContainer style={{ margin: 0 }}>
				<div className="sandbox">
					<h2 style={{ marginBottom: "15px" }}>Get Started with BankConnect</h2>

					<ScrollingCard style={{ height: "inherit" }}>
						<h3>Resources</h3>
						<p>
							To understand the integration flow, check out our documentation or try
							BankConnect using Postman.
						</p>
						<div className="resourceButton">
							<OutlineButton onClick={() => window.open(`${key.DocLink}`, "_blank")}>
								{" "}
								Documentation <FiExternalLink style={{ marginLeft: 5 }} />
							</OutlineButton>
							<OutlineButton
								noMargin="true"
								onClick={() => window.open(`${key.PostmanLink}`, "_blank")}
							>
								{" "}
								Postman Collection <FiExternalLink style={{ marginLeft: 5 }} />
							</OutlineButton>
						</div>
					</ScrollingCard>
					<ScrollingCard style={{ height: "inherit" }}>
						<div
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "space-between",
								marginBottom: "15px",
							}}
						>
							<h3 style={{ margin: 0 }}>Credentials</h3>
							<DeveloperContainer>
								<SwitchDeveloper onClick={() => setEnv("dev")} stage={env}>
									Dev
								</SwitchDeveloper>
								<SwitchDeveloper onClick={() => setEnv("prod")} stage={env}>
									Prod
								</SwitchDeveloper>
							</DeveloperContainer>
						</div>
						<p>
							Developers can copy the below Integration keys and use them in their workflow.
							For security reasons, keys are hidden by default.
						</p>
						{key &&
							key.Env[`${env}`] &&
							key.Env[`${env}`][0].Keys.map((keyBlock) => (
								<RowContainer>
									<div className="key">
										<Code>{keyBlock.Name}</Code>
									</div>
									<div className="value">
										<Showhide password={keyBlock.Value}></Showhide>
									</div>
								</RowContainer>
							))}
					</ScrollingCard>
					<ScrollingCard style={{ height: "inherit" }}>
						<h3>Client SDK Sample Projects</h3>
						<p>
							Client SDK provides a drop-in module to securely upload statements on FinBox
							BankConnect either manually or via net-banking. Check out the sample
							implementations for React and Android
						</p>
						<div style={{ display: "flex" }}>
							<OutlineButton
								onClick={() =>
									window.open("https://github.com/finbox-in/bankconnect-react", "_blank")
								}
							>
								{" "}
								<FaReact style={{ marginRight: 5 }} /> React
							</OutlineButton>
							<OutlineButton
								onClick={() =>
									window.open("https://github.com/finbox-in/bankconnect-android", "_blank")
								}
							>
								{" "}
								<MdAndroid style={{ marginRight: 5 }} /> Android
							</OutlineButton>
						</div>
					</ScrollingCard>
					<ScrollingCard style={{ height: "inherit" }}>
						<h3>REST API Quick Start</h3>
						<p>Select your preferred language</p>
						<LanguageList>
							<li>
								<Label active={language == "python"} onClick={() => setLanguage("python")}>
									Python
								</Label>
							</li>

							<li>
								<Label active={language == "java"} onClick={() => setLanguage("java")}>
									Java
								</Label>
							</li>
							<li>
								<Label
									active={language == "javascript"}
									onClick={() => setLanguage("javascript")}
								>
									NodeJS
								</Label>
							</li>
							<li>
								<Label active={language == "ruby"} onClick={() => setLanguage("ruby")}>
									Ruby
								</Label>
							</li>
							<li>
								<Label active={language == "go"} onClick={() => setLanguage("go")}>
									Go
								</Label>
							</li>
						</LanguageList>
						<p>
							{language == "java"
								? `${java.text}`
								: language == "python"
								? `${python.text}`
								: language == "javascript"
								? `${nodejs.text}`
								: language == "ruby"
								? `${ruby.text}`
								: language == "go"
								? `${go.text}`
								: ""}
						</p>

						<div
							ref={high}
							dangerouslySetInnerHTML={{
								__html:
									language == "python"
										? `${python.code}`
										: language == "java"
										? `${java.code}`
										: language == "javascript"
										? `${nodejs.code}`
										: language == "ruby"
										? `${ruby.code}`
										: language == "go"
										? `${go.code}`
										: "",
							}}
						/>
					</ScrollingCard>
				</div>
			</SandboxContainer>
		</Main>
	);
}
export default Sandbox;
